<script setup lang="ts">
    const { id = 'default-id', validationErrors = [] } = defineProps<{
        id?: string;
        validationErrors?: string[];
    }>();
    const { t } = useI18n();
</script>

<template>
    <div
        v-if="validationErrors.length > 0"
        :id="`error-${id}`"
        class="error"
    >
        <div
            v-for="error in validationErrors"
            :key="error"
        >
            {{ t(error) }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/form/form-errors.scss';
</style>
